/* Pop Shop Quick Add */
(function () {
  'use strict';

  function updateCartIndicator() {
    var indicators = document.querySelectorAll('.site-header__cart-indicator');
    indicators.forEach(function (indicator) {
      indicator.classList.remove('hide');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-popshop-quick-add]');
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = button.textContent.trim();
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'ADDING…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || 'Unable to add this item.');
          });
        }
        return response.json();
      })
      .then(function () {
        updateCartIndicator();
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        button.textContent = 'ADDED—YAY! 🎉';

        window.setTimeout(function () {
          button.disabled = false;
          button.classList.remove('is-added');
          button.textContent = originalText;
        }, 1800);
      })
      .catch(function () {
        button.classList.remove('is-loading');
        button.textContent = 'TRY AGAIN';
        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = originalText;
        }, 2200);
      });
  });
})();